import React, { useEffect, useState } from "react";
import { updateReport } from "../../firebase/firebase";
import ReportItems from "../reportItems/reportItems";
import '../../css/homepage.css'

const Report = ({ values }) => {
  // report
  const [report, setReport] = useState({
    title: "",
    des: "",
  });

  const [reports, setReports] = useState([]);

  // handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setReport({
      ...report,
      [name]: value,
    });
  };

  // send report
  const sendReport = async () => {
    await updateReport(values?.email, report).then(() => {
      window.location.reload();
    });
  };

  // handle submit
  const handleSubmit = (e) => {
    e.preventDefault();
    sendReport();
  };

  // useeffect
  useEffect(() => {
    setReports(values?.report);
  }, []);
  return (
    <div className="lg:px-12">
      <div>
        <p className="text-xl font-semibold py-2 title">Submit a Report</p>
      </div>
      <div className="lg:grid grid-cols-5 lg:space-x-5 mx-2">
        <div className="col-span-2 bg-[#434242] my-4 h-96 text-center py-3 rounded-sm shadow-lg">
          <div className="space-y-1 px-4">
            <p className="text-sm font-semibold text-white">Enter your report</p>
            <p className="text-xs text-white">
              Go ahead to explain challenges you face in Paytron our team will
              get back to you within 24hrs
            </p>
          </div>
          <div>
            <form
              onSubmit={handleSubmit}
              className="text-start px-8 py-6 space-y-4"
            >
              <div className=" space-y-1">
                <label className="text-xs font-normal py-2 leading-4 text-white">
                  Report Title
                </label>
                <input
                  id="title"
                  type="text"
                  className="py-2 w-full p-2 text-sm bg-white/60 rounded-md"
                  name="title"
                  placeholder="Enter report title"
                  value={report.title}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className=" space-y-1">
                <label className="text-xs font-normal py-2 leading-4 text-white">
                  Report Description
                </label>
                <input
                  id="des"
                  type="text"
                  className="py-2 w-full h-[6rem] p-2 text-sm bg-white/60 rounded-md"
                  name="des"
                  placeholder="Enter complaint"
                  value={report.des}
                  onChange={handleChange}
                  required
                />
              </div>
              <div>
                <button
                  type="submit"
                  className="flex text-white bg-[#22f4fa]/60 justify-center items-center w-full cursor-pointer p-3 font-medium text-center rounded-sm text-sm"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
        <div className="col-span-3 bg-[#434242] h-[80vh] lg:px-4">
          <div>
            <p className="text-center font-semibold text-lg text-white">Previous Report</p>
          </div>
          <>
            <div className=" overflow-y-scroll w-full">
              <div>
                {reports.map((item, i) => (
                  <ReportItems report={item} key={i} />
                ))}
              </div>
            </div>
          </>
        </div>
      </div>
    </div>
  );
};

export default Report;
